/**
 * Ask backend to refresh the league feed if it's older than 2 minutes.
 * For shark users (shrk=1) this updates the UD file instead of PP projections.
 */
export default async function RefreshFeedIfStale(sport, shrk = 0) {
  // For shark mode we allow sport to be optional because UD file is global
  const sportSegment = sport ? encodeURIComponent(String(sport).toLowerCase()) : '';
  const url = `/wp-json/wagedwar/v1/feed-refresh-if-stale/${sportSegment}`;

  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ shrk }),
      cache: 'no-store',
    });

    if (!res.ok) {
      // Don't block UI; log for debugging only
      console.warn('RefreshFeedIfStale: non-OK response', res.status);
      return null;
    }

    const data = await res.json();
    return data;
  } catch (e) {
    console.error('RefreshFeedIfStale: fetch error', e);
    return null;
  }
}
